import { lazy, Suspense, useEffect } from "react";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import { useSeo } from "../hooks/useSeo";
import { useNavigate } from "react-router-dom";

const Products = lazy(() => import("../components/Products"));
const SolutionsGrid = lazy(() => import("../components/SiteBlocks").then((m) => ({ default: m.SolutionsGrid })));
const Showreel = lazy(() => import("../components/Showreel"));
const About = lazy(() => import("../components/About"));
const Gallery = lazy(() => import("../components/Gallery"));
const Cities = lazy(() => import("../components/Cities"));
const Contact = lazy(() => import("../components/Contact"));

const Section = ({ children }) => <Suspense fallback={null}>{children}</Suspense>;

export default function HomePage() {
    const navigate = useNavigate();
    useSeo({ path: "/" });

    // legacy QR stickers encode /#warranty?w=SERIAL — forward them to the warranty page
    useEffect(() => {
        const h = window.location.hash || "";
        if (h.startsWith("#warranty")) navigate(`/warranty${h.includes("?") ? h.slice(h.indexOf("?")) : ""}`, { replace: true });
    }, [navigate]);

    return (
        <div data-testid="home-page">
            <Hero />
            <Marquee />
            <div className="home-deferred">
                <Section><Products linkMode /></Section>
                <Section><SolutionsGrid /></Section>
                <Section><Showreel /></Section>
                <Section><About /></Section>
                <Section><Gallery /></Section>
                <Section><Cities /></Section>
                <Section><Contact /></Section>
            </div>
        </div>
    );
}
